import { createContext } from "react";
import { Team } from "../types";

export declare type SelectedTeamContext = {
  selectedTeam: Team | null;
  setSelectedTeam: (team: Team | null) => void;
};

export const selectedTeamCtx = createContext<SelectedTeamContext>({
  selectedTeam: null,
  setSelectedTeam: () => { }
});

